import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
import { logActivity } from "../../../utils/LogActivity";
import { AuthContext } from "../../../Context/AuthContext";
import { toast } from "react-toastify";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={labelStyle}>{label}</label>
    {children}
  </div>
);

const SInput = (props) => (
  <input style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"} {...props} />
);
const SSelect = ({ children, ...props }) => (
  <select style={{ ...inputStyle, cursor: "pointer" }} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"} {...props}>{children}</select>
);
const STextarea = (props) => (
  <textarea style={{ ...inputStyle, resize: "vertical", minHeight: 80 }} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"} {...props} />
);

const Meetings = () => {
  const [meetingType, setMeetingType] = useState("");
  const [meetingNotes, setMeetingNotes] = useState("");
  const [meetingDate, setMeetingDate] = useState("");
  const [meetingAttendees, setMeetingAttendees] = useState("");
  const [meetingMinutes, setMeetingMinutes] = useState(null);
  const [vfcId, setVfcId] = useState("");
  const [vfcs, setVfcs] = useState([]);
  const [previousMeetings, setPreviousMeetings] = useState([]);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editMeetingId, setEditMeetingId] = useState(null);
  const Api = process.env.REACT_APP_API;
  const { userId, selectedJfmcType } = useContext(AuthContext);
  const MAX_FILE_SIZE = 1 * 1024 * 1024;
  const [vfcMeetings, setVfcMeetings] = useState([]);

  useEffect(() => {
    if (selectedJfmcType) { setVfcId(""); setPreviousMeetings([]); fetchVfc(selectedJfmcType._id); }
    handleFetchPreviousMeetings();
  }, [selectedJfmcType]);

  const fetchVfc = async (jfmcTypeId) => {
    setLoading(true);
    try {
      const config = Authorization();
      const res = await axios.post(`${Api}/api/vfcs/names`, { jfmcTypeId }, config);

      const prepared = res.data.vfcs.map((vfc) => ({
        ...vfc,
        meetingType: "",
        meetingNotes: "",
        meetingDate: "",
        meetingAttendees: "",
        meetingMinutes: null,
      }));

      setVfcs(res.data.vfcs);
      setVfcMeetings(prepared);

    } catch (err) {
      console.error("Error fetching VFCs", err);
    } finally {
      setLoading(false);
    }
  };

  const handleRowChange = (index, field, value) => {
    const updated = [...vfcMeetings];
    updated[index][field] = value;
    setVfcMeetings(updated);
  };

  const handleFileChangeRow = (index, file) => {
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      setError("File size must be ≤ 1 MB.");
      return;
    }

    const updated = [...vfcMeetings];
    updated[index].meetingMinutes = file;
    setVfcMeetings(updated);
  };


  const handleFetchPreviousMeetings = async () => {
    try {
      setLoading(true);
      const config = Authorization();

      const res = await axios.post(
        `${Api}/api/vfc/previous`,
        {}, // ✅ no vfcId needed
        config
      );

      setPreviousMeetings(res.data);
    } catch (err) {
      console.error(err);
      setPreviousMeetings([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEditMeeting = (meeting) => {
    const index = vfcMeetings.findIndex(
      (v) => v._id === meeting.vfcId._id
    );

    if (index === -1) return;

    const updated = [...vfcMeetings];

    updated[index] = {
      ...updated[index],
      meetingId: meeting._id, // ✅ IMPORTANT
      meetingType: meeting.meetingType,
      meetingNotes: meeting.meetingSummary,
      meetingDate: meeting.meetingDate.split("T")[0],
      meetingAttendees: meeting.meetingAttendees || "",
    };

    setVfcMeetings(updated);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => { setEditMeetingId(null); setMeetingType(""); setMeetingNotes(""); setMeetingDate(""); setMeetingAttendees(""); setMeetingMinutes(null); };

  const handleSubmitAll = async () => {
    try {
      setLoading(true);
      const config = Authorization();

      const validRows = vfcMeetings.filter(
        (v) => v.meetingType && v.meetingDate
      );

      if (validRows.length === 0) {
        setError("Please fill at least one meeting");
        return;
      }

      const promises = validRows.map(async (v) => {
        const fd = new FormData();

        fd.append("vfcId", v._id);
        fd.append("meetingType", v.meetingType);
        fd.append("meetingAttendees", v.meetingAttendees || 0);
        fd.append("meetingSummary", v.meetingNotes);
        fd.append("meetingDate", v.meetingDate);

        if (v.meetingMinutes) {
          fd.append("uploadDocument", v.meetingMinutes);
        }

        // ✅ CHECK EDIT OR CREATE
        if (v.meetingId) {
          return fetch(`${Api}/api/vfc/meetings/${v.meetingId}`, {
            method: "PUT", // ✅ UPDATE
            headers: { ...config.headers },
            body: fd,
          });
        } else {
          return fetch(`${Api}/api/vfc/meetings`, {
            method: "POST", // ✅ CREATE
            headers: { ...config.headers },
            body: fd,
          });
        }
      });

      await Promise.all(promises);

      setSuccessMessage("All meetings submitted successfully");
      // ✅ RESET TABLE FORM
      toast.success("Meetings added successfully");
      await logActivity(userId, "New Meetings Added", "Add Meetings Page", Api);
      resetAllRows();

      // OPTIONAL: refresh previous meetings
      handleFetchPreviousMeetings();
    } catch (err) {
      console.error(err);
      setError("Failed to submit meetings");
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteMeeting = async (meetingId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Meeting record?"
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      const config = Authorization();

      await axios.delete(
        `${Api}/api/vfc/meetings/${meetingId}`,
        config
      );

      toast.success("Meeting deleted successfully");

      // remove from UI instantly
      setPreviousMeetings((prev) =>
        prev.filter((meeting) => meeting._id !== meetingId)
      );

      // reset edit state if deleted item was being edited
      setEditMeetingId(null);
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete meeting");
    } finally {
      setLoading(false);
    }
  };
  const resetAllRows = () => {
    const resetData = vfcs.map((vfc) => ({
      ...vfc,
      meetingId: null, // ✅ RESET
      meetingType: "",
      meetingNotes: "",
      meetingDate: "",
      meetingAttendees: "",
      meetingMinutes: null,
    }));

    setVfcMeetings(resetData);
  };

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Meeting Reports</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>JFMC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Meetings</span>
        </div>
      </div>

      {/* ── Alerts ── */}
      {error && (
        <div style={{ marginBottom: 14, padding: "10px 14px", background: "#FFEBEE", border: "1px solid #FFCDD2", borderRadius: 8, fontSize: 13, color: "#C62828", display: "flex", alignItems: "center", gap: 8 }}>
          <i className="mdi mdi-alert-circle-outline" /> {error}
        </div>
      )}
      {successMessage && (
        <div style={{ marginBottom: 14, padding: "10px 14px", background: "#E8F5E9", border: "1px solid #C8E6C9", borderRadius: 8, fontSize: 13, color: "#2E7D32", display: "flex", alignItems: "center", gap: 8 }}>
          <i className="mdi mdi-check-circle-outline" /> {successMessage}
        </div>
      )}

      {/* ── No JFMC type selected ── */}
      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {/* ── Form Card ── */}
          <div style={{ flex: "0 0 42%", background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
              <span style={{ width: 36, height: 36, background: "rgba(255,255,255,0.15)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 18 }}>
                <i className="mdi mdi-calendar-check-outline" />
              </span>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>{editMeetingId ? "Edit Meeting" : "Record Meeting"}</div>
            </div>

            <div style={{ padding: 20 }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr>
                    {["#", "VFC Name", "Type", "Date", "Attendees", "Notes", "File"].map((h) => (
                      <th key={h} style={{
                        padding: "10px",
                        borderBottom: "1px solid #E2E8F0",
                        background: "#F7FAFC",
                        fontSize: 12
                      }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {vfcMeetings.map((vfc, index) => (
                    <tr key={vfc._id} style={{
                      borderBottom: "1px solid #EDF2F7"
                    }}>
                      <td style={{ padding: 8, }}>{index + 1}</td>

                      <td style={{ padding: 8, fontWeight: 600 }}>
                        {vfc.vfcName}
                      </td>

                      <td style={{ padding: 8 }}>
                        <SSelect
                          value={vfc.meetingType}
                          onChange={(e) => handleRowChange(index, "meetingType", e.target.value)}
                          style={inputStyle}
                        >
                          <option value="">Select</option>
                          <option value="EC Meetings">EC Meetings</option>
                          <option value="General Body">General Body</option>
                        </SSelect>
                      </td>

                      <td style={{ padding: 8 }}>
                        <SInput
                          type="date"
                          value={vfc.meetingDate}
                          onChange={(e) => handleRowChange(index, "meetingDate", e.target.value)}
                          style={inputStyle}
                        />
                      </td>

                      <td style={{ padding: 8 }}>
                        <SInput
                          type="number"
                          min={0}
                          value={vfc.meetingAttendees}
                          onChange={(e) => handleRowChange(index, "meetingAttendees", e.target.value)}
                          style={inputStyle}
                        />
                      </td>

                      <td style={{ padding: 8 }}>
                        <STextarea
                          as="textarea"
                          value={vfc.meetingNotes}
                          onChange={(e) => handleRowChange(index, "meetingNotes", e.target.value)}
                          style={inputStyle}
                        />
                      </td>

                      <td style={{ padding: 8 }}>
                        <input
                          type="file"
                          onChange={(e) => handleFileChangeRow(index, e.target.files[0])}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button
                onClick={handleSubmitAll}
                style={{
                  marginTop: 15,
                  padding: "10px 20px",
                  background: "linear-gradient(135deg,#1B5E20,#2E7D32)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: 600,
                  cursor: "pointer"
                }}
              >
                Submit All
              </button>
            </div>
          </div>

          {/* ── Previous Meetings Card ── */}
          <div style={{ flex: 1, background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
              <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
                <i className="mdi mdi-history" />
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Previous Meetings</span>
              <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 50 }}>{previousMeetings.length}</span>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr>
                    {["#", "JFMC Name", "Meeting Type", "Date", "Notes", "Action"].map((h) => (
                      <th key={h} style={{ padding: "11px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "#4A5568", borderBottom: "1px solid #EDF2F7", background: "#F7FAFC", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {previousMeetings.length === 0 ? (
                    <tr><td colSpan={6} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: 13 }}>No meetings recorded yet</td></tr>
                  ) : (
                    previousMeetings.map((m, i) => (
                      <tr key={m._id} style={{ borderBottom: "1px solid #EDF2F7" }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#F7FAFC"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                        <td style={{ padding: "10px 14px", color: "#718096" }}>{i + 1}</td>
                        <td style={{ padding: "10px 14px", color: "#1A202C", fontWeight: 600 }}>{m.vfcId.vfcName}</td>
                        <td style={{ padding: "10px 14px" }}>
                          <span style={{ background: "#E8F5E9", color: "#2E7D32", fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 50 }}>{m.meetingType}</span>
                        </td>
                        <td style={{ padding: "10px 14px", color: "#4A5568", whiteSpace: "nowrap" }}>{new Date(m.meetingDate).toLocaleDateString("en-IN")}</td>
                        <td style={{ padding: "10px 14px", color: "#4A5568", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.meetingSummary}</td>
                        <td style={{ padding: "10px 14px" }}>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              onClick={() => handleEditMeeting(m)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "5px 12px",
                                background: "linear-gradient(135deg,#1B5E20,#2E7D32)",
                                color: "#fff",
                                border: "none",
                                borderRadius: 7,
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer"
                              }}
                            >
                              <i className="mdi mdi-pencil" style={{ fontSize: 13 }} />
                              Edit
                            </button>

                            <button
                              onClick={() => handleDeleteMeeting(m._id)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "5px 12px",
                                background: "linear-gradient(135deg,#C62828,#E53935)",
                                color: "#fff",
                                border: "none",
                                borderRadius: 7,
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer"
                              }}
                            >
                              <i className="mdi mdi-delete" style={{ fontSize: 13 }} />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Meetings;
